/*
 * Copyright (C) 2026 - present Marek Kuzora - All Rights Reserved.
 */


import { Card, Flex } from '@radix-ui/themes';

import Text from 'solis/react/primitive/text';

import Section from 'solis/claude/primitive/section';

import ViewBoard from 'solis/claude/button/view.board';
import Deploy from 'solis/claude/button/deploy';


const Component = ({ colony, account, owner }) =>
(
  <Card>
    <Flex direction = 'column' gap = '3'>

      <Section label = 'Colony'>
        {owner && <Text.Note>{'Authority: ' + colony.cass.authority}</Text.Note>}
      </Section>

      <ViewBoard colony = {colony} />
      <Deploy colony = {colony} account = {account} />

    </Flex>
  </Card>
);


export default ({ colony, account }) =>
{
  const owner = colony.cass.user === account.cass.id;

  if (!owner && !colony.cass.board)
  {
    return null;
  }

  return <Component colony = {colony} account = {account} owner = {owner} />;
};
